import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';
import SideMenu from '../../../components/sideMenu';
import Header from '../../../components/header';

import moment from 'moment';

export default class SearchEngineList extends Component {
	constructor(props) {
        super(props);
        this.state = {
            searchEngines: []
        }
    }
    
    getSearchEngines() {
        apiGetRequest("search/list/?team=" + this.props.team.url_identifier, "", true, this.props.authToken).then((data) => {
            console.log(data);
            this.setState({searchEngines: data.results});
            this.props.changeAppLoading(false);
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

    componentDidMount() {
        this.getSearchEngines();
        this.props.mixpanel.track("Viewed Search Engine List")
    }

    renderUpToDate(item) {
        var a = moment(item.last_updated);
        var b = moment();
        var diff = b.diff(a, "days");
        if (diff < 5) {
            return(<p style={{color: '#34AA44'}}>Up to date</p>)
        } else if (diff > 5) {
            return(<p style={{color: "#FACF55"}}>Scheduled for update</p>)
        }
    }


	render() {
		return (
			<div class={cx("home")}>
                <Header />

                <div class={cx("content")}>
                    <h2>{this.props.team.team_name}'s Search Engines</h2>
                    <div class={cx("options")}>
                        {this.state.searchEngines.map((item) => (
                            <div class={cx("option-base")} onClick={() => {
                                this.props.mixpanel.track("Clicked on Search Engine", {
                                    search_engine_id: item.id
                                });
                                route("/search/engine/" + item.id);
                            }}>
                                <p class={cx("emoji")}>🔍</p>
                                <p class={cx("name")}>{item.name}</p>
                                {this.renderUpToDate(item)}
                            </div>
                        ))}
                    </div>
                </div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./routes/search/SearchEngineList/index.js